import { SummaryTable } from "@components/SummaryTable/SummaryTable";

export const SummaryStep = () => {
  return <SummaryTable />;
};
